// ecoHeatwave brand mark — concentric heatwave rings derived from the
// Circle Pattern 1 motif (rings emanating outward in the brand palette).
export default function BrandLogo({ tone = "dark", size = 28, withText = true }) {
  const isLight = tone === "light";
  const titleId = "eco-heatwave-logo";
  return (
    <span className="inline-flex items-center gap-2.5" aria-label="ecoHeatwave">
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        role="img"
        aria-labelledby={titleId}
        className="shrink-0"
      >
        <title id={titleId}>ecoHeatwave</title>
        {/* Outer ring — Golden Sand */}
        <circle cx="16" cy="16" r="13.5" fill="none" stroke="#FFD682" strokeWidth="1.6" />
        {/* Middle ring — Inviting Amber */}
        <circle cx="16" cy="16" r="9" fill="none" stroke="#F4B369" strokeWidth="1.6" />
        {/* Inner ring — Sunset Orange */}
        <circle cx="16" cy="16" r="4.5" fill="none" stroke="#F65900" strokeWidth="1.8" />
        {/* Centre dot — Rustic Terracotta */}
        <circle cx="16" cy="16" r="1.4" fill="#983519" />
      </svg>
      {withText && (
        <span
          className={`font-display text-[17px] tracking-tight transition-colors duration-300 ${
            isLight ? "text-white drop-shadow-[0_1px_8px_rgba(0,0,0,0.4)]" : "text-ecoh-ink"
          }`}
        >
          <span className="font-light">eco</span>
          <span className="font-medium">Heatwave</span>
        </span>
      )}
    </span>
  );
}
